import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { Clock, Bug, Users, BarChart3 } from "lucide-react";
const HerausforderungenITSection = () => <IndustryChallengesI18n translationPrefix="industryIT" icons={[Clock, Bug, Users, BarChart3]} />;
export default HerausforderungenITSection;
